import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { OnDestroyMixin } from '@w11k/ngx-componentdestroyed';
import { BehaviorSubject, of } from 'rxjs';
import { catchError, filter, take, tap } from 'rxjs/operators';

import { TransactionsMsService } from 'src/app/dashboard/bankAccounts/transactions-ms.service';
import { SnackbarService } from '../../../services/snackbar.service';
import { UtilsService } from '../../../services/utils.service';
import { ExportTransactionsParameters } from './export-transactions-parameters.model';
@Component({
  selector: 'terra-export-transactions-menu',
  templateUrl: './export-transactions-menu.component.html',
  styleUrls: ['./export-transactions-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExportTransactionsMenuComponent extends OnDestroyMixin {
  @Input() isDisabled: boolean;
  @Input("exportTransactionsParameters") exportTransactionsParameters: ExportTransactionsParameters;
  @Output() exportFormat: EventEmitter<string> = new EventEmitter<string>();


  public isExporting$ = new BehaviorSubject(false);

  constructor(
    private snackbarService: SnackbarService,
    private utilsService: UtilsService,
    private transactionsServiceMs: TransactionsMsService
  ) {
    super();
  }

  exportTransactions(fileType: 'excel' | 'csv') {
    this.isExporting$.next(true);
    this.transactionsServiceMs.exportTransactions(
      fileType,
      this.exportTransactionsParameters.bankAccountId,
      this.exportTransactionsParameters.searchOptions,
      this.exportTransactionsParameters.bankType
    ).pipe(
      take(1),
      filter(fileUrl => !!fileUrl),
      // tap(fileUrl => this.utilsService.downloadFileFromUrl(fileUrl)),
      catchError(_ => of(this.snackbarService.showGeneralMessage('Failed exporting transactions. Please contact support.'))),
      tap(() => this.isExporting$.next(false))
    ).subscribe()
    //this.exportFormat.emit(fileType);
  }
}
